module.exports = __webpack_public_path__ + "img/motionbank-logo.ba7f6876.png";